import { useCallback, useState } from 'react'
import {
  RefreshControl
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'

// components & screens
import BasicInformationForm from '../../components/home/forms/BasicInformationForm'

const PersonalBasicInfromationScreen = ({ navigation, route }: any): JSX.Element => {
  const [refreshing, setRefreshing] = useState(false)

  // pull down to refresh the screen
  const onRefresh = useCallback(() => {
    setRefreshing(true)
    setTimeout(() => {
      navigation.replace('PersonalBasicInformation', { refresh: Math.random() })
      setRefreshing(false)
    }, 1000)
  }, [])

  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps={'handled'}
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      // extraHeight={160}
      // extraScrollHeight={160}
      contentContainerStyle={{ flexGrow: 1, }}
      refreshControl={
        <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
      }
    >
      <BasicInformationForm navigation={navigation} route={route} />
    </KeyboardAwareScrollView>
  )
}

export default PersonalBasicInfromationScreen
